import type { Recipe } from '../../types'
import { image, ingredient, section } from '../helpers'

export const patesChataignes: Recipe = {
  slug: 'pates-chataignes',
  title: 'Pâtes aux châtaignes',
  category: 'salé',
  description: 'Une sauce riche et crémeuse, proposée pour 400 g ou 500 g de pâtes.',
  image: image('pates-chataignes'),
  tags: ['pâtes', 'châtaignes', 'crème'],
  meta: [
    { label: 'Préparation', value: '10 à 15 min' },
    { label: 'Cuisson', value: '10 min' },
  ],
  sections: [
    section('400 g de pâtes', [
      ingredient('chataignes-400', 'châtaignes cuites', '15 à 20 châtaignes (200 g) cuites, concassées', {
        amount: 200,
        unit: 'g',
        shoppingKey: 'châtaignes',
      }),
      ingredient('lardons-400', 'lardons', '100 g de lardons', {
        amount: 100,
        unit: 'g',
        shoppingKey: 'lardons',
      }),
      ingredient('echalotes-400', 'échalotes', '2 échalotes finement ciselées', {
        amount: 2,
        unit: 'échalote',
        shoppingKey: 'échalote',
      }),
      ingredient('matiere-grasse-400', 'beurre et huile d’olive', 'Beurre et huile d’olive'),
      ingredient('vin-400', 'vin blanc sec', '15 cl de vin blanc sec', {
        amount: 15,
        unit: 'cl',
        shoppingKey: 'vin blanc',
      }),
      ingredient('parmesan-400', 'parmesan râpé', '40 g de parmesan râpé', {
        amount: 40,
        unit: 'g',
        shoppingKey: 'parmesan',
      }),
      ingredient('creme-400', 'crème fraîche liquide', '30 cl de crème fraîche liquide', {
        amount: 30,
        unit: 'cl',
        shoppingKey: 'crème',
      }),
      ingredient('pates-400', 'pâtes', '400 g de pâtes (type tagliatelle / penne)', {
        amount: 400,
        unit: 'g',
        shoppingKey: 'pâtes',
      }),
      ingredient('assaisonnement-400', 'sel et poivre', 'Sel, poivre'),
    ]),
    section('500 g de pâtes', [
      ingredient('chataignes-500', 'châtaignes cuites', '20 à 25 châtaignes (≈ 250 g) cuites, concassées', {
        amount: 250,
        unit: 'g',
        shoppingKey: 'châtaignes',
      }),
      ingredient('lardons-500', 'lardons', '125 g de lardons', {
        amount: 125,
        unit: 'g',
        shoppingKey: 'lardons',
      }),
      ingredient('echalotes-500', 'échalotes', '3 échalotes finement ciselées', {
        amount: 3,
        unit: 'échalote',
        shoppingKey: 'échalote',
      }),
      ingredient('matiere-grasse-500', 'beurre et huile d’olive', 'Beurre et huile d’olive'),
      ingredient('vin-500', 'vin blanc sec', '20 cl de vin blanc sec', {
        amount: 20,
        unit: 'cl',
        shoppingKey: 'vin blanc',
      }),
      ingredient('parmesan-500', 'parmesan râpé', '50 g de parmesan râpé', {
        amount: 50,
        unit: 'g',
        shoppingKey: 'parmesan',
      }),
      ingredient('creme-500', 'crème fraîche liquide', '40 cl de crème fraîche liquide', {
        amount: 40,
        unit: 'cl',
        shoppingKey: 'crème',
      }),
      ingredient('pates-500', 'pâtes', '500 g de pâtes (type tagliatelle / penne)', {
        amount: 500,
        unit: 'g',
        shoppingKey: 'pâtes',
      }),
      ingredient('assaisonnement-500', 'sel et poivre', 'Sel, poivre'),
    ]),
  ],
  steps: [
    'Écraser les châtaignes cuites avec une fourchette ou un pilon jusqu’à obtenir une texture grossière (garder éventuellement quelques morceaux plus gros).',
    'Mettre une grande casserole d’eau à bouillir (pour que l’eau soit prête au bon moment).',
    'Dans une poêle, faire revenir les lardons à feu moyen jusqu’à légère coloration.',
    'Ajouter un peu de beurre et un filet d’huile d’olive, puis faire suer les échalotes 5 à 6 minutes sans les laisser brunir.',
    'Déglacer avec le vin blanc sec (environ 20 cl) et laisser réduire jusqu’à ce qu’il ne reste presque plus de liquide.',
    'Ajouter les châtaignes, mélanger 1 minute.',
    'Verser la crème (37,5 cl) et laisser frémir 2 à 4 minutes, jusqu’à obtenir une sauce onctueuse.',
    'Pendant que la sauce réduit, saler l’eau bouillante et cuire les pâtes al dente selon les indications du paquet. Réserver une tasse d’eau de cuisson.',
    'Baisser le feu (ou couper). Ajouter le parmesan, mélanger, puis rectifier l’assaisonnement (poivre + sel si besoin).',
    'Ajouter les pâtes dans la poêle, mélanger avec la sauce et ajouter un peu d’eau de cuisson pour lier (au besoin, en plusieurs fois).',
  ],
  note: 'Astuce : pour plus de texture, concasser quelques châtaignes en morceaux plus gros et en ajouter au dernier moment.',
}
